// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RecommendedJobs from './pages/RecommendedJobs';
import RecommendedCandidates from './pages/RecommendedCandidates';
import MyConnections from './pages/MyConnections';  // 引入“我的关系”页面
import NavBar from './components/NavBar'; // 导航栏
import Footer from './components/Footer';
import UserProfile from './pages/UserProfile';  // 引入用户信息页面

function App() {
    return (
        <Router>
            <NavBar />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/recommended-jobs" element={<RecommendedJobs />} />
                <Route path="/recommended-candidates" element={<RecommendedCandidates />} />
                <Route path="/connections" element={<MyConnections />} />
                <Route path="/profile" element={<UserProfile />} />
                {/* 在这里添加更多页面 */}
            </Routes>

            {/* 底部区域 */}
            <Footer />
        </Router>
    );
}

export default App;